<template>
	<div class="Create">
		<CreateProfile_Form />
	</div>
</template>

<script>
import CreateProfile_Form from '../../components/organisms/forms/CreateProfile_Form'

export default {
	name: 'Create_view',
	components: {
		CreateProfile_Form
	}
}
</script>

<style lang="scss">
.Create {
	min-height: 100vh;
	padding: 40px 0;
	box-sizing: border-box;
	background: radial-gradient(circle, #949eb1 0%, #697791 100%);

	@include for-tablet-portrait-up {
		padding: 100px 0;
	}

	.input__container,
	.select__container {
		margin-top: 20px;
	}

	> * {
		margin-left: auto;
		margin-right: auto;
	}
}
</style>
